module.exports = __webpack_public_path__ + "img/wolf.bc302b9d.png";